
import React from 'react';
import { useSession } from "@/hooks/useSession";
import { useNavigate, useLocation } from 'react-router-dom';
import PageHeader from "@/components/common/PageHeader";
import FAQSection from "@/components/support/FAQSection";
import ContactForm from "@/components/support/ContactForm";

const SupportPage = () => {
  const { session } = useSession();
  const navigate = useNavigate();
  const location = useLocation();

  // Determine if user came from landing page or dashboard
  const isFromLandingPage = location.pathname === '/support' || !session;
  const backPath = isFromLandingPage ? '/' : '/app/dashboard';

  return (
    <div className="container mx-auto py-8 px-4">
      <PageHeader 
        title="Support Center" 
        showBackButton={true}
        backTo={backPath}
        description="Get help and support for your VirtuStaff AI team"
      />
      
      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
        <div>
          <FAQSection />
        </div>
        
        <div>
          <ContactForm 
            initialName={session?.user?.user_metadata?.full_name || ""} 
            initialEmail={session?.user?.email || ""}
          />
        </div>
      </div>
    </div>
  );
};

export default SupportPage;
